var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2934_10782)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 2.00033C4.68637 2.00033 2.00008 4.68662 2.00008 8.00033C2.00008 11.314 4.68637 14.0003 8.00008 14.0003C11.3138 14.0003 14.0001 11.314 14.0001 8.00033C14.0001 4.68662 11.3138 2.00033 8.00008 2.00033ZM0.666748 8.00033C0.666748 3.95024 3.94999 0.666992 8.00008 0.666992C12.0502 0.666992 15.3334 3.95024 15.3334 8.00033C15.3334 12.0504 12.0502 15.3337 8.00008 15.3337C3.94999 15.3337 0.666748 12.0504 0.666748 8.00033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17216 5.34987C7.86181 5.29664 7.54264 5.35496 7.27117 5.5145C6.9997 5.67405 6.79346 5.92452 6.68897 6.22155C6.56679 6.56888 6.18618 6.7514 5.83885 6.62921C5.49153 6.50703 5.30901 6.12642 5.43119 5.7791C5.64017 5.18502 6.05266 4.68408 6.5956 4.36499C7.13853 4.0459 7.77688 3.92926 8.39757 4.03573C9.01826 4.14219 9.58125 4.4649 9.98682 4.94668C10.3923 5.42836 10.6143 6.03798 10.6134 6.6676C10.6132 7.38104 10.238 7.92635 9.85015 8.29794C9.46217 8.66966 9.00213 8.92759 8.67733 9.08318C8.65139 9.09561 8.63254 9.11339 8.6221 9.12873C8.61723 9.13587 8.61507 9.14117 8.61417 9.14394C8.6134 9.14635 8.61341 9.14732 8.61341 9.14748V9.33366C8.61341 9.70185 8.31494 10.0003 7.94675 10.0003C7.57856 10.0003 7.28008 9.70185 7.28008 9.33366V9.1475C7.28008 8.56762 7.64578 8.09892 8.10129 7.88071C8.36559 7.7541 8.68427 7.56843 8.92773 7.33517C9.17122 7.10188 9.28008 6.88101 9.28008 6.66699L9.28008 6.666C9.28055 6.35112 9.16957 6.04624 8.96678 5.80534C8.764 5.56445 8.48251 5.4031 8.17216 5.34987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 11.3337C8.66675 11.7018 8.36827 12.0003 8.00008 12.0003C7.63189 12.0003 7.33341 11.7018 7.33341 11.3337C7.33341 10.9655 7.63189 10.667 8.00008 10.667C8.36827 10.667 8.66675 10.9655 8.66675 11.3337Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2934_10782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.cfc012a6065563ccabc71c6fff18a29b.svg";
export { ForwardRef as ReactComponent };